import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

import { Store } from '@ngrx/store';
import { combineLatest, Observable, map, take } from 'rxjs';

import { hasOrderData } from '@fcom/common-booking';

import { StateActions, getStage } from '../../../store';
import { MmbStage } from '../../../enums';

export const ancillaryPurchaseReviewGuard: CanActivateFn = (): Observable<boolean> => {
  const store$ = inject(Store);

  return combineLatest([store$.pipe(hasOrderData()), store$.pipe(getStage())]).pipe(
    take(1),
    map(([hasBooking, stage]: [boolean, MmbStage]) => {
      if (hasBooking) {
        if (stage !== MmbStage.REVIEW) {
          store$.dispatch(StateActions.setStage({ stage: MmbStage.REVIEW }));
        }
        return true;
      }

      store$.dispatch(StateActions.setStage({ stage: MmbStage.LOGIN }));

      return false;
    })
  );
};
